(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["image"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__accordionImageLightboxInit) return;
    window.__accordionImageLightboxInit = true;

    function ensureLightbox() {
      var existing = document.querySelector('[data-accordion-lightbox-root]');
      if (existing) return existing;

      var root = document.createElement('div');
      root.className = 'accordion-lightbox';
      root.setAttribute('data-accordion-lightbox-root', '');
      root.setAttribute('hidden', '');

      root.innerHTML =
        '<div class="accordion-lightbox__backdrop" data-accordion-lightbox-close></div>' +
        '<div class="accordion-lightbox__dialog" role="dialog" aria-modal="true" aria-label="Image viewer">' +
          '<button type="button" class="accordion-lightbox__close" data-accordion-lightbox-close aria-label="Close">×</button>' +
          '<img class="accordion-lightbox__img" data-accordion-lightbox-img alt="">' +
        '</div>';

      document.body.appendChild(root);
      return root;
    }

    function openLightbox(src, alt) {
      var lb = ensureLightbox();
      var img = lb.querySelector('[data-accordion-lightbox-img]');
      img.src = src;
      img.alt = alt || '';
      lb.hidden = false;
      document.documentElement.style.overflow = 'hidden';
    }

    function closeLightbox() {
      var lb = document.querySelector('[data-accordion-lightbox-root]');
      if (!lb || lb.hidden) return;
      var img = lb.querySelector('[data-accordion-lightbox-img]');
      img.src = '';
      img.alt = '';
      lb.hidden = true;
      document.documentElement.style.overflow = '';
    }

    document.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-accordion-lightbox-open]');
      if (openBtn) {
        var src = openBtn.getAttribute('data-accordion-lightbox-src');
        var alt = openBtn.getAttribute('data-accordion-lightbox-alt') || '';
        if (src) openLightbox(src, alt);
        return;
      }

      var closeBtn = e.target.closest('[data-accordion-lightbox-close]');
      if (closeBtn) closeLightbox();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeLightbox();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
